webpackJsonp([72776394686286],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.postsQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsPage = function NewsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "section",
	    { className: "main wrapper style2" },
	    _react2.default.createElement(
	      "header",
	      { className: "major" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        "News"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          data.allBlogEntries.edges.map(function (edge) {
	            var post = edge.node;
	            return _react2.default.createElement(
	              "div",
	              {
	                className: "blog-entry col-12 col-12-narrow col-12-mobilep",
	                key: post.id
	              },
	              _react2.default.createElement(
	                "h3",
	                null,
	                post.title
	              ),
	              _react2.default.createElement(
	                "h4",
	                null,
	                post.date
	              ),
	              _react2.default.createElement("div", {
	                dangerouslySetInnerHTML: { __html: post.content },
	                className: "content"
	              }),
	              _react2.default.createElement("hr", null)
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewsPage;
	var postsQuery = exports.postsQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-js-1d09a09ef697c2ddde20.js